import React from "react";

const ROW_BASE = "tw-flex tw-items-center tw-gap-2 tw-w-full tw-border-0 tw-bg-transparent tw-text-left tw-px-2.5 tw-py-2 tw-rounded-[var(--cf-radius-sm)] tw-text-[14px] tw-font-semibold tw-text-primary hover:tw-bg-[color:var(--cf-color-surface-hover)]";
const ROW_ACTIVE = "tw-bg-primary !tw-text-primary-500";
const ICON_BASE = "tw-shrink-0 tw-w-[18px] tw-text-[15px] tw-text-[color:var(--cf-color-text-muted-dark)]";
const CARET_BASE = "tw-shrink-0 tw-w-3 tw-text-[15px] tw-text-[color:var(--cf-color-text-muted)]";
const LABEL = "tw-min-w-0 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap";

const Tree = ({
    items,
    expandedFolders,
    onToggleFolder,
    onSelectPage,
    selectedPageId,
    level = 0
}) => {
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    return (
        <ul className={`tw-list-none tw-m-0 tw-p-0${level > 0 ? " tw-pl-[18px]" : ""}`}>
            {items.map((item) => {
                const isFolder = item?.type === "folder" || (item?.children?.length ?? 0) > 0;
                const isExpanded = Boolean(expandedFolders[item.id]);
                const isSelected = selectedPageId === item.id;

                return item.status == "current" && (
                    <li className="tw-m-0" key={item.id}>
                        <button
                            className={`${ROW_BASE}${isSelected ? ` ${ROW_ACTIVE}` : ""}`}
                            onClick={() => {
                                if (isFolder) {
                                    onToggleFolder(item.id);
                                    return;
                                }

                                onSelectPage(item.id);
                            }}
                            type="button"
                            title={item?.title}
                        >
                            {isFolder ? (
                                <span className={`${CARET_BASE} fa ${isExpanded ? "fa-angle-down" : "fa-angle-right"}`} />
                            ) : null}
                            {isFolder ? (
                                <span className={`${ICON_BASE} fa ${isExpanded ? "fa-folder-open-o" : "fa-folder-o"}`} />
                            ) : (
                                <span className={`${ICON_BASE} fa fa-file-text-o`} />
                            )}
                            <span className={LABEL}>{item.title}</span>
                        </button>
                        {isFolder && isExpanded ? (
                            <Tree
                                expandedFolders={expandedFolders}
                                items={item.children}
                                level={level + 1}
                                onSelectPage={onSelectPage}
                                onToggleFolder={onToggleFolder}
                                selectedPageId={selectedPageId}
                            />
                        ) : null}
                    </li>
                );
            })}
        </ul>
    );
};

export default Tree;
